export enum PhoneNumberStatus {
    Pending,
    Imported,
    Exported,
    Ordered
}